<template>
  <div class="container register-container login-container">
    <div class="box" v-loading="loading">
      <div class="logo">
        <img src="@/assets/logo.png" alt="logo">
      </div>
      <h2 class="title">{{ $t('register.register') }} Thundersend.me</h2>
      <el-form :model="registerForm" :rules="rules" ref="registerForm">
        <el-form-item prop="email">
          <el-input 
            v-model="registerForm.email" 
            :placeholder="$t('register.enterEmail')"
            prefix-icon="el-icon-user"
            >
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input 
            v-model="registerForm.password" 
            type="password" 
            :placeholder="$t('register.enterPassword')"
            prefix-icon="el-icon-lock">
          </el-input>
        </el-form-item>

        <el-form-item prop="verCode">
          <div class="verify-code">
            <el-input 
              v-model="registerForm.verCode" 
              :placeholder="$t('register.enterVerCode')"
              prefix-icon="el-icon-message">
            </el-input>
            <a class="code-btn" @click="handleGetVerifyCode" v-if="!countdown">{{ $t('reset.getCode') }}</a>
            <span class="code-btn disable-btn" v-else>{{ countdown }}</span>
          </div>
        </el-form-item>

        <el-form-item prop="invitationCode">
          <el-input 
            v-model="registerForm.invitationCode" 
            :placeholder="$t('register.inviteCode')"
            prefix-icon="el-icon-chat-line-round">
          </el-input>
        </el-form-item>
        <el-button type="primary" class="submit-btn" @click="handleRegister">{{ $t('register.register') }}</el-button>
      </el-form>

      <div class="bottom-link">
        {{ $t('register.hadAccount') }}？<router-link to="/login">{{ $t('register.clickLogin') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { register, getVerifyCode, login } from '@/api/user'

export default {
  name: 'UserRegister',
  data() {
    return {
      registerForm: {
        email: '',
        password: '',
        verCode: '',
        invitationCode: ''
      },
      loading: false,
      countdown: 0,
      rules: {
        email: [
          { required: true, message: this.$t('register.enterEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('reset.vaildEamil'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('register.enterPassword'), trigger: 'blur' },
          { min: 6, message: this.$t('register.validPassword'), trigger: 'blur' }
        ],
        verCode: [
          { required: true, message: this.$t('reset.verCodeRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 从路由query中获取invitationCode
    const { invitationCode } = this.$route.query;
    if (invitationCode) {
      this.registerForm.invitationCode = invitationCode;
    }
  },
  methods: {
    async handleRegister() {
      const valid = await this.$refs.registerForm.validate();
      if (!valid) {
        return;
      }
      try {
        this.loading = true
        this.registerForm.phoneNumber = "13000000000";
        this.registerForm.name = this.registerForm.email;
        const res = await register(this.registerForm);
        const loginRes = await login({
          name: this.registerForm.email,
          password: this.registerForm.password,
          rememberMe: true
        });
        const obj = {
          token: loginRes.token,
          name: this.registerForm.email,
          time: new Date().getTime()
        }
        // 保存token
        localStorage.setItem('_token', JSON.stringify(obj))
        // 跳转到首页或其他页面
        this.$router.push('/hot')
        this.$message.success(this.$t('register.registerSuccess'))
      } catch (error) {
        console.error('注册失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleGetVerifyCode() {
      if (this.countdown > 0) return;
      this.$refs.registerForm.validateField('email', async (valid) => {
        if (valid) {
          // valid为false表示验证未通过
          return;
        }
        // 验证通过
        this.loading = true;
        try {
          await getVerifyCode(this.registerForm.email);
          this.$message.success(this.$t('reset.verCodeSend'));
          this.countdown = 60;
          this.startCountdown();
        } catch (error) {
          console.error('验证码发送失败:', error);
        } finally {
          this.loading = false;
        }

      });
    },
    startCountdown() {
      const timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/login-common.scss';
.register-container {
  background-image: var(--register-bg-url);
}

.verify-code {
  position: relative;
  .code-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .disable-btn {
    color: #909399;
  }
}

.submit-btn {
  width: 100%;
  margin-top: 20px;
}

@media screen and (max-width: 768px) {
  .box {
    padding: 20px;
  }
  .logo {
    margin-bottom: 0;
  }
  .logo img {
    height: 100px;
  }
  .title {
    margin-top: 0;
  }
}
</style> 